import { constants, Globals } from '../../../../misc/helpers';
import MainTestScenario from './MainTestScenario';

export default class MainTestScenarioStep1 {
	private noThreatAssessed = false;
	constructor(private mainScenario: MainTestScenario, private onDone: (aarReady1: boolean) => void, public showFailedAar: () => void, startTitle?:string, startTitleText?:string) {
		this.startTitle = startTitle;
		this.startTitleText = startTitleText;
	}

	public startTitle: string = '';
	public startTitleText: string = '';
	public start() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.ScenarioStart, {
			onClose: () => {
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.GenericModal, {
					text: "Would you like to return to the main menu?",
					okBttn: {
						text: 'Yes',
						onClick: () => {
							context.mainScenario.showMainMenu();
						}
					},
					cancelBttn: {
						text: 'No',
						onClick: () => {
							context.start();
						}
					}
				});
			},
			onDone: () => {
				this.part2RotateCameraWithBystander();
			},
			title: context.startTitle,
			text: context.startTitleText,
		});
		this.part1BleedoutTimer();
		Globals.stopTimer = true;
	}

	private part1BleedoutTimer() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			startTimeInSeconds: 240,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true,
			setDelayed: true
		});

		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.PauseMenu, {
			timer: {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				startTimeInSeconds: 240,
				onTimeRanOut: () => {
					this.showFailedAar();
				},
				isActive: true
			}
		});
	}

	private part2RotateCameraWithBystander() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.ScenarioStart);
		this.mainScenario.rotateCamera(() => context.part3Call911(), () => context.part2RotateCameraWithBystanderIsNotSufficient());
	}

	private part2RotateCameraWithBystanderIsNotSufficient() {
		this.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Call911);
	}

	private part3Call911() {
		var context = this;
		if(!this.noThreatAssessed) {
			context.mainScenario.playSound('Step-21', '21', () => {
				context.mainScenario.playSound('Step-1', '2');
			});
			this.noThreatAssessed = true;
		}

		// context.gameManager.UiManager.hideUi(constants.InGameUINames.RotateCamera);
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Call911, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onClick: (onResume: () => void) => {
				this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
					dispatch: this.mainScenario.gameManager.customData.dispatch,
					onTimeRanOut: () => {
						this.showFailedAar();
					},
					isActive: true,
					setDelayed: false
					});
				Globals.stopTimer = false;
				context.mainScenario.gameManager.UiManager.hideaAllUis();
				context.mainScenario.playSound('Step-1', '3', () => {
					context.mainScenario.playSequence('BystanderPlayLips');
					context.mainScenario.playSound('Step-1', '4', () => {
						context.mainScenario.playSequence('BystanderStopLips');
						context.mainScenario.playSound('Step-1', '4.5', () => {
							setTimeout(() => {
								context.mainScenario.playSound('Step-1', '5', () => {
								});
							}, 1500);
						});
					});
				});
					onResume();
			},
			onDone: () => {
				if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
					return;
				}
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.RotateCamera);
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Call911);
				context.part4PlaySequence();
				context.mainScenario.playSequence('VictimPlayLips');

					context.mainScenario.playSound('Step-1', '6', () => {
						context.mainScenario.playSequence('VictimStopLips');

				});
			}
		});
	}

	private part4PlaySequence() {
		var context = this;
		if(this.mainScenario.stepsOrder1 === true) {
			context.mainScenario.aarCalled911 = true;
		}
		else {context.mainScenario.aarCalled911 = false;}

		this.mainScenario.aarPDScenarioD = true;
			context.part5IsPatientSafe();
		
		// context.mainScenario.playSequence('Step1NonInteractiveSequence', null, () => {
		// 	context.part5IsPatientSafe();
		// });
	}

	private part5IsPatientSafe() {
		var context = this;
		context.mainScenario.incorrectPathChosen = true;
		this.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Is the victim in a safe area and on a hard surface?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.part10ShouldPatientBeMovedNo()
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioStep1.part5IsPatientSafe', () => context.part6ShouldPatientBeMoved())
			}
		});
	}

	private part6ShouldPatientBeMoved() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to move the victim to another area?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioStep1.part6ShouldPatientBeMoved', () => context.part7TimePenalty())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.part5IsPatientSafe()
			}
		});
	}

	private part7TimePenalty() {
		var context = this;
		context.mainScenario.aarCalled911 = true;
		context.mainScenario.incorrectPathChosen = false;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			penalized: true,
			timePenaltyInSeconds: 28,
			setRedEffect: true,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Moving victim to another area!'});
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.part8MoveVictim();
		context.mainScenario.playSound('Step-1', '7', () => {
	});

	}

	private part8MoveVictim() {
		var context = this;
		context.mainScenario.playSequence('Step1SetPatientLocation', null, () => {
			this.mainScenario.playSequence('DisableBystander');
			setTimeout(() => {
				context.part9IsPatientSafe();
			}, 2500);
		});
	}

	private part9IsPatientSafe() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Is the victim in a safe area and on a hard surface?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioStep1.part9IsPatientSafe', () => context.part10ShouldPatientBeMovedNo())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.part10ShouldPatientBeMoved()
			}
		});
	}

	private part10ShouldPatientBeMoved() {
		var context = this;
		
		this.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to move the victim to another area?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.part10ShouldPatientBeMovedYes()
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioStep1.part10ShouldPatientBeMoved', () => context.part9IsPatientSafe())
			}
		});
	}

	private part10ShouldPatientBeMovedYes() {
		var context = this;
		context.mainScenario.aarCalled911 = false;
		context.mainScenario.incorrectPathChosen = true;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			penalized: true,
			timePenaltyInSeconds: 28,
			setRedEffect: true,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Moving victim to another area!'});
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.part10MoveVictim();
		context.mainScenario.playSound('Step-1', '7', () => {
	});

	}

	private part10MoveVictim(){
		var context = this;
		context.mainScenario.playSequence('Step2SetPatientLocation', null, () => {
			setTimeout(() => {
				context.part5IsPatientSafe();
			}, 2500);
		});
	}

	private part10ShouldPatientBeMovedNo() {
		Globals.stopTimer = true;
		if(this.mainScenario.stepsOrder1 === true) {
			this.onDone(true);
		}
		else {
			this.onDone(false);
		}
	}
}